import React, { useEffect, useState, useRef } from 'react'
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from "moment";
import { leaveService } from '../../../services/extensions';
import { capitalize } from '../../../services/utility/helper';
import { Util } from '../../../services';
import { utitService } from '../../../services/util';

const ManagerUpcomingEvents = ({ duration }) => {
    const localizer = momentLocalizer(moment);
    const [eventsData, setEventsData] = useState([]);
    const [leaveData, setLeaveData] = useState([]);

    useEffect(() => {
        fetchCelebrationsData();
    }, [duration]);

    const fetchCelebrationsData = async () => {
        try {
            const response = await leaveService.GetUserBirthdayAndAnnviversaryBySuperior(utitService.dateParser(duration, 'YYYY-MM-DD'), 'Y');
            const events = response.data.data.map(e => {
                const sd = new Date(e.eventDate);
                const ed = new Date(e.eventDate);
                const start = e.leaveType === 'FD' ? new Date(sd.getFullYear(), sd.getMonth(), sd.getDate(), 0, 0, 0) : sd;
                const end = e.leaveType === 'FD' ? new Date(ed.getFullYear(), ed.getMonth(), ed.getDate(), 23, 59, 59) : ed;
                return {
                    title: `${capitalize(e.firstName)} ${capitalize(e.lastName)} - ${e.event}`,
                    start: start,
                    end: end,
                    absCode: e.absenceCode,
                    type: e.leaveType,
                    reason: e.event,
                    allDay: true,
                    backgroundColor: "#" + Math.floor(Math.random() * 16777215).toString(16)
                };
            }).flat();
            setEventsData(events);
        } catch (error) {
            console.error('Error fetching celebrations data:', error);
        }
    };

    const getLeaves = () => {
        leaveService.getEmployeeLeavesBySuperior().then(resp => {
            const events = resp.data.data.map(employee => {
                return employee.Leaves.map(leave => {
                    const sd = new Date(leave.startDate);
                    const ed = new Date(leave.endDate);
                    const start = leave.leaveType === 'FD' ? new Date(sd.getFullYear(), sd.getMonth(), sd.getDate(), 0, 0, 0) : sd;
                    const end = leave.leaveType === 'FD' ? new Date(ed.getFullYear(), ed.getMonth(), ed.getDate(), 23, 59, 59) : ed;
                    return {
                        title: `${capitalize(employee.firstName)} ${capitalize(employee.lastName)} - ${leave.reasonOfLeave}`,
                        start: start,
                        end: end,
                        absCode: leave.absenceCode,
                        type: leave.leaveType,
                        reason: leave.reasonOfLeave,
                        allDay: true,
                        backgroundColor: "#" + Math.floor(Math.random() * 16777215).toString(16)
                    };
                });
            }).flat();
            setEventsData(events);
        });
    };


    const handleSelect = ({ start, end }) => {

    };

    const handleEventMouseEnter = (arg) => {
        arg.el.style.backgroundColor = '#FFD700'; // Change the background color to gold on hover
        const tooltip = document.createElement('div');
        tooltip.classList.add('calendar-tooltip');
        tooltip.innerHTML = `
       ${arg.event.extendedProps.absCode}<br>
       ${arg.event.extendedProps.type}<br>
       ${arg.event.extendedProps.reason}<br>
       ${Util.dateConverterForLeave(arg.event.start)}<br>
    `;
        arg.el.appendChild(tooltip);
    };

    const handleEventMouseLeave = (arg) => {
        arg.el.style.backgroundColor = arg.event.backgroundColor; // Restore the original background color
        const tooltips = document.querySelectorAll('.calendar-tooltip');
        tooltips.forEach(tooltip => tooltip.remove());
    };

    return (
        <>
            <div className="field w-100 col-12" style={{ fontWeight: '500' }} >
                <Calendar
                    views={["day", "work_week", "month"]}
                    selectable
                    localizer={localizer}
                    defaultDate={new Date()}
                    defaultView="month"
                    events={eventsData}
                    style={{ height: "calc(100vh - 230px)" }}
                    onSelectEvent={(event) => console.log(event.title)}
                    onSelectSlot={handleSelect}
                />
            </div>
        </>
    );
};

export default ManagerUpcomingEvents;